<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info">
        <div slot="header">
              Centro de Custo
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=finance/costcenter')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>

        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
           
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Centro de Custo</span></b-button>
              </b-form-group>
            </b-col>
           
          </b-row>
              
  
          <b-row>

            <b-col cols="auto">
              <b-form-group >
                  <label for="perPage">Empresa</label>
                  <b-form-select v-model="filters.companyId" id="filterCompany"
                    :plain="true"
                    :options="this.companyDDL"
                    @change="refreshByCompany(filters.companyId)"
                    >
                  </b-form-select>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(st)="data">
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Centro de Custo"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">

          <b-row v-show="selectedItem && selectedItem.id && selectedItem.id > 0">
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Código"
                label-for="code"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.code" id="code" type="text" class="w-25"  readonly></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Principal"
                label-for="parent"
                :label-cols="3"
                :horizontal="true">
                <b-form-select id="parent"
                    v-model="selectedItem.parentId"
                    :plain="true"
                    :options="selectCostCenterDDL"
                    :value="[null,'c']">
                </b-form-select>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>


          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Centro de Custo"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.name" id="name" type="text" :class="nameField"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Descrição"
                label-for="description"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.description"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Centro de Custo</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', parentId: 0, _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        nameField: '',
        costCenterDDL: [],
        companyDDL: [],
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          key: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
          //{key: 'id' },
          {key: 'code', label: 'Código', sortable: true, thStyle: { width: "140px" } },
          {key: 'name', label: 'Centro de Custo', sortable: true },
          //{key: 'description', label: 'Descrição', sortable: true },
          //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' || 
                this.$utils.filterString(item.name, this.filters.key)  
              
            })
        }
        catch(e) {
            return this.items;
        }
      },
      selectCostCenterDDL: function() {
          var list = [...this.costCenterDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '-' })
          return list
      }
    },
    methods: {
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
      
      async saveItem(item) {
        var s = this
       
        await axios.post(
            this.$store.state.ws_url + "/costcenter",
            item
        ).then(function(resp) {
            console.log(resp)

            s.closeEditModal()
            s.getCostCenter()
            s.refreshData()
          }
        ).catch(function (error) {
          console.log(error)
          toast ({
            type: VueNotifications.types.error,
            title: 'Centro de Custo',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
        });

      },

      save() {
        var noError=true
        
        if(!this.selectedItem.name || this.selectedItem.name.length <= 0) {
          noError = false
          this.nameField = 'is-invalid'
        }
        else {
          this.nameField = ''
        }

        if(noError) {
          this.selectedItem.companyId = this.filters.companyId
          this.selectedItem.uid = this.$store.state.currentUser.id;
          this.selectedItem.sid = this.$store.state.currentUser.sid;
          this.saveItem(this.selectedItem)
        }
      },
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }

        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            if(item == null) {
                this.selectedItem = newItem;      
            }
            else {
                this.selectedItem = JSON.parse(JSON.stringify(item));
            }
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      refreshByCompany(companyId) {
        
      },

      async getCostCenter() {
        var s = this
        var currentUser = this.$store.state.currentUser;
        //console.log(this.$store.state.ws_url + "/costcenter/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)
          await axios.get(
              this.$store.state.ws_url + "/costcenter/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.costCenterDDL = resp.data.obj;
          }).catch(function(resp) {
            console.log(resp)
          })
        
      },

      async refreshData() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;
          await axios.get(
              this.$store.state.ws_url + "/costcenter?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.items = resp.data.obj;
          }).catch(function(resp) {
            console.log(resp)
          })
        
          this.isBusy = false;
      },
      openHelp(url) {
        window.open(this.$store.state.config.ws_help + url, '_blank')
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      var companyId = this.$store.state.config.companyId
      this.filters.companyId = companyId
      this.getCostCenter()
      this.refreshData()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>